/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GcpResourceSkuDetailsRequest {
    getFixupPrototypeFunction() { return GcpResourceSkuDetailsRequest.fixupPrototype; }

    static newInstance(model: Partial<GcpResourceSkuDetailsRequest>): GcpResourceSkuDetailsRequest {
        let obj = Object.assign(new GcpResourceSkuDetailsRequest(), model);
        GcpResourceSkuDetailsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GcpResourceSkuDetailsRequest>): GcpResourceSkuDetailsRequest {
        if (!model) return null;
        return GcpResourceSkuDetailsRequest.newInstance(<GcpResourceSkuDetailsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GcpResourceSkuDetailsRequest) {
        if (!obj) return;

        models.GcpResourceSkuDetailsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GcpResourceSkuDetailsRequest): boolean {
        Object.setPrototypeOf(obj, GcpResourceSkuDetailsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.region) {
            models.LocationDetailsBase.fixupPrototype(this.region);
        }
    }

    /**
     * ID of the service account
     */
    service_account_id: string;

    /**
     * Id of the resource
     */
    resource_id: string;

    /**
     * Type of the resource
     */
    resource_type: string;

    /**
     * Category of the resource
     */
    resource_category: string;

    /**
     * Name of the resource
     */
    resource: string;

    /**
     * Optional region details
     */
    region: models.LocationDetailsBase;

}
